import { render, staticRenderFns } from "./BatchCopyPrevious.vue?vue&type=template&id=aff50c1c"
import script from "./BatchCopyPrevious.vue?vue&type=script&lang=js"
export * from "./BatchCopyPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports